import React from "react";

import { Box, Typography, Button } from "@mui/material";
import Modal from "@mui/material/Modal";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
  clientName?: string | null;
  fromLabel?: string;
  toLabel?: string;
};

const useStyles = makeStyles()((theme) => ({
  root: {
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(24, 24),
    backgroundColor: colors.white,
    overflowY: "auto",
    width: "470px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      margin: 0,
    },
  },
  content: {
    padding: "40px",
    [theme.breakpoints.down("md")]: {
      padding: "24px",
    },
  },
  header: {
    fontSize: "20px",
    fontWeight: 700,
    marginBottom: "20px",
  },
  message: {
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "20px",
    textAlign: "center",
  },
  schedule: {
    fontSize: "14px",
    marginBottom: "4px",
    textAlign: "center",
    color: "#5B6472",
    "& b": {
      color: colors.dark,
    },
  },
  buttons: {
    marginTop: "16px",
  },
}));

const StyledBackButton = withStyles(Button, {
  root: {
    color: "#949BA8",
    border: "2px solid #949BA8",
    marginRight: 8,
    "&:hover": {
      color: "#949BA8",
      border: "2px solid #949BA8",
    },
  },
});

const RescheduleAppointmentModal: React.FC<ModalProps> = ({
  open,
  onClose,
  handleConfirm,
  clientName,
  fromLabel,
  toLabel,
}) => {
  const { classes } = useStyles();
  return (
    <Modal open={open} onClose={onClose} className={classes.root}>
      <Box className={classes.modalBody}>
        <Box className={classes.content}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography className={classes.header}>
              Reschedule Appointment?
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography className={classes.message}>
              Move the appointment
              {clientName ? ` with ${clientName}` : ""} to the new schedule?
            </Typography>
          </Box>
          {fromLabel && (
            <Typography className={classes.schedule}>
              From: <b>{fromLabel}</b>
            </Typography>
          )}
          {toLabel && (
            <Typography className={classes.schedule}>
              To: <b>{toLabel}</b>
            </Typography>
          )}
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className={classes.buttons}
          >
            <StyledBackButton variant="outlined" onClick={onClose}>
              Keep Current Time
            </StyledBackButton>
            <Button color="primary" onClick={handleConfirm}>
              Reschedule
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default RescheduleAppointmentModal;
